/**
 * Press Release Single
 */

import pinShareIconsOnScroll from "../animations/pinShareIconsOnScroll";

const PressReleaseSingle = () => {

	if ( document.body.classList.contains( 'single-press_release' ) ) {
		pinShareIconsOnScroll(".single-press_release .blog__share__container", ".single-press_release #pin");
	}

};

export default PressReleaseSingle;
